import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useCurrentOrganization } from '@/components/features/membership/membership-provider';
import {
  Page,
  PageContent,
  PageHeader,
  PageHeaderAction,
  PageHeaderDescription,
  PageHeaderInfo,
  PageHeaderTitle,
} from '@/components/ui/layout/page';
import { CalendarButton } from './-parts/calendar-button';
import { TimelineCard } from './-parts/timeline-card';
import { FeedbackCard } from './-parts/feedback-card';

export const Route = createFileRoute('/_authenticated/me/')({
  component: MePage,
});

function MePage() {
  const organization = useCurrentOrganization();
  const { t } = useTranslation();

  return (
    <Page>
      <PageHeader>
        <PageHeaderInfo>
          <PageHeaderTitle>{t('authenticated.me.title')}</PageHeaderTitle>
          <PageHeaderDescription>
            {t('authenticated.me.description')}
          </PageHeaderDescription>
        </PageHeaderInfo>

        <PageHeaderAction>
          <CalendarButton />
        </PageHeaderAction>
      </PageHeader>

      <PageContent>
        {/* Current Month (timeline) */}
        <div className="mt-6">
          <TimelineCard organizationId={organization.organizationId} />
        </div>

        {/* Feedback List */}
        <div className="mt-6">
          <FeedbackCard organizationId={organization.organizationId} />
        </div>
      </PageContent>
    </Page>
  );
}
